import * as React from 'react';
import { t } from 'i18next';

import { OAPPopupState } from './OAPActionsPopup';
import { SelectBoxOption } from '../../../stores/SelectBoxStore';
import { OAPActions } from '../../../actions/OAPActions';
import { BasePopupMenuTitleSetting } from '../BasePopupMenuHeader';
import { BasePopupMenuContent } from '../BasePopupMenuContent';
import { LayoutType } from '../../../constants/LayoutConstants';

import core = egr.wcf.core;
import utils = egr.wcf.utils;

export class OAPClasses extends React.Component<OAPPopupState, {}> {
    public render(): JSX.Element {
        return (
            <BasePopupMenuContent
                transform={true}
                defaultValue={null}
                flagPosition={this.props.position.flagPosition}
                open={this.props.showEditor}
                options={this.options()}
                title={this.title()}
                alignBottom={this.props.layoutType === LayoutType.SMALL}
            />
        );
    }

    protected options = (): Array<SelectBoxOption> => {
        return this.props.classes.map(this.mapPropertyClassToSelectBoxOption).filter(this.notNull);
    };

    protected mapPropertyClassToSelectBoxOption = (value: core.prop.PropertyClass, index: number): SelectBoxOption | null => {
        const properties: Array<core.prop.Property> = this.props.properties.filter((property: core.prop.Property) => {
            return property.class === value.key;
        });
        if (properties.length === 0) {
            return null;
        }
        return {
            name: value.getName(),
            key: index + '-c',
            className: 'egr-select-option-no-icon egr-select-option-arrow',
            callback: () => {
                if (properties.length === 1) {
                    OAPActions.setSelectedProperty(properties[0]);
                } else {
                    OAPActions.setSelectedClass(value);
                }
            }
        };
    };

    protected notNull(value: SelectBoxOption | null): value is SelectBoxOption {
        return value != null;
    }

    protected title = (): BasePopupMenuTitleSetting => {
        return {
            label: (utils.string.isNullOrEmpty(this.props.title) ? t('Properties') : this.props.title),
            className: '',
            callback: OAPActions.hideDialog
        };
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/OAP/OAPClasses.tsx